




























import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { AppActionTypes, AppGetterTypes, GetOrder } from "../store";
import { IPromotionModel, IOrderModel, ICheckoutModel } from "../models";

import {
    pushPageView,
    pushSubscribe,
    ConversionItemModel,
    GtmPageType
} from "../tracking";

@Component({ name: "ThankYou" })
export default class ThankYou extends Vue {
    @Prop({ required: true })
    promotionSlug!: string;

    @Prop({ required: true })
    orderId!: string;

    @Getter(AppGetterTypes.checkout)
    checkout!: ICheckoutModel;

    @Getter(AppGetterTypes.order)
    order!: IOrderModel;

    @Action(AppActionTypes.getOrder)
    getOrder!: GetOrder;

    get imgAltText(): string {
        if (!this.order.items) {
            return "Product Image";
        }

        let itemsNameString;
        for (const item of this.order.items) {
            if (!itemsNameString) {
                itemsNameString = item.name;
            } else {
                itemsNameString += " and " + item.name;
            }
        }
        const itemName =
            this.order.items.length > 1
                ? itemsNameString
                : this.order.items[0].name;

        return itemName + " Product Image";
    }

    get promotion(): IPromotionModel | null {
        if (this.order) {
            return this.order.promotion || null;
        }

        return null;
    }

    async mounted(): Promise<void> {
        await this.getOrder(this.orderId);

        if (!this.order.viewed) {
            this.runConversionScripts();
        }
    }

    /**
     * Pushes GTM events
     */
    runConversionScripts(): void {
        // Send Google subscribe event
        this.sendGoogleData();
    }

    async sendGoogleData(): Promise<void> {
        // Send GTM pageView event
        await pushPageView(GtmPageType.Cart);

        if (
            !this.order ||
            !this.order.id ||
            !this.order.promotionCode ||
            !this.order.orderTotal ||
            !this.order.hashedEmail
        ) {
            return;
        }

        let conversionItems: Array<ConversionItemModel> =
            this.order.items?.map(item => {
                return {
                    id: item.externalId || "",
                    name: item.name || "",
                    price: item.price || 0,
                    qty: 1
                };
            }) || [];

        //Calculate order subtotal (order item price sum)
        let subtotal =
            this.order.items?.reduce(
                (sum, item) => sum + (item.price ?? 0),
                0
            ) ?? 0;

        await pushSubscribe(
            this.order.id,
            this.order.promotionCode,
            this.order.orderTotal,
            subtotal,
            String(this.order.isSoftDeclined),
            GtmPageType.ConversionConfirmation,
            this.order.hashedEmail,
            conversionItems
        );
    }
}
